import { axiosDefaultInstance } from '@/http/default'

import type { CompanyRequest } from '@/model/Company'
import type { EmployeeRequest } from '@/model/Employee'
import type { FeatureFlagsGlobal } from '@/model/FeatureFlagsGlobal'
import type { AxiosInstance } from 'axios'
import handleError from './util/ErrorHandler'
import type { ServiceError } from './util/ServiceError'


export interface CompanyRegistrationRequest {
  company: Omit<CompanyRequest, 'id'>
  employee: Omit<EmployeeRequest, 'id'>
}

class ApiService {
  private axiosInstance: AxiosInstance


  constructor() {
    this.axiosInstance = axiosDefaultInstance
    
  }

  async getFeatureFlagsGlobal(): Promise<FeatureFlagsGlobal | ServiceError> {
    
    const params: string[][] = []
    const searchParams = new URLSearchParams(params)

    try {
      const networkResponse = await this.axiosInstance.get<FeatureFlagsGlobal>(
        `${import.meta.env.VITE_API_BASE_URL}/feature-flags-global`,
        { params: searchParams }
      )
      return networkResponse.data
    } catch (error) {
      return handleError(error)
    }
  }

}

export const apiService = new ApiService()
